<template>
  <div class="page-section">
      <div class="breadcrumbs-custom box-transform-wrap context-dark">
        <div class="container">
          <h3 class="breadcrumbs-custom-title">Galerija</h3>
          <div class="breadcrumbs-custom-decor"></div>
        </div>
        <vue-load-image>
          <div slot="image" alt="slight production galerija slika" class="box-transform" :data-src="require('./../images/galerija/bg-slight-production-galerija.jpg')" :style="{ backgroundImage: 'url(' + require('./../images/galerija/bg-slight-production-galerija.jpg') + ')' }"></div>
          <div slot="preloader" class="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>          
          <div slot="error">učitavam sliku...</div>
        </vue-load-image>         
      </div>  
    <section class="section photo_gallery section_responsive bg-gray-lighter" id="galerija">
        <div class="box-spacer">
          <!-- <p class="heading-1">Galerija</p><br/> -->
          <div class="categories">
                <ul class="type">
                  <li v-for="category in categories" :key="category.id">
                      <a class="button button-primary-outline" v-bind:class="[category.isActive ? 'active' : '']" @click="filterByCategory(category.id)">{{category.name}}</a>
                  </li>                
                </ul>
          </div>
        </div>
          <div class="shell-fluid-mobile shell-condensed">
            <div class="range range-condensed" data-lightgallery="group">
              <div v-for="(image, index) in images" :key="index" class="cell-sm-6 cell-md-4 cell-lg-3 image-item">
                  <a class="thumb-ruby thumb-mixed_height-4" @click="showModalWindow(index)" data-lightgallery="group-item">
                    <img class="thumb-ruby__image" :src="getSrcLink(index)" :alt="image" width="400" height="363">
                    <div class="thumb-ruby__caption"> 
                      <!-- <p class="thumb-ruby__title heading-3">Image #1</p>
                      <p class="thumb-ruby__text">If you are looking for high quality wedding photography, I will be glad to help you.</p> -->
                    </div>
                  </a>
              </div>
            </div>
          </div>

          <div v-bind:class="[modalIsActive ? 'in' : 'hidden']" class="lg-backdrop" style="transition-duration: 150ms;"></div>
          <div v-bind:class="[modalIsActive ? 'show-image' : 'hidden']" class="image-gallery-modal lg-outer lightGallery-in-carousel lg-css3 lg-use-transition-for-zoom lg-visible show-image">
            <div class="modal-gallery-navigation" v-bind:class="[images.length <= 1 ? 'hidden' : '']">
                <img src="./../icons/arrow_left.png" alt="close icon" class="modal-navigation-arrow left" @click="sliderPrev()">
                <img src="./../icons/arrow_right.png" alt="close icon" class="modal-navigation-arrow right" @click="sliderNext()">
            </div>
            <div v-touch:swipe="swipeHandler" class="lg" style="width:100%; height:100%">
              <div class="lg-inner" style="transition-timing-function: ease; transition-duration: 600ms;">
                <div class="lg-item lg-next-slide lg-prev-slide lg-loaded lg-current lg-complete lg-zoomable">
                  <div class="lg-img-wrap">
                    <img class="lg-object lg-image" :src="getSrcLink(this.currentID)">
                  </div>
                </div>
              </div>
              <div class="close-icon-container">
                <img src="./../icons/close_icon.png" alt="close icon" class="modal-close-icon" @click="closeModalWindow()">
              </div>         
            </div>
          </div>        
    </section>
  </div>  
</template>

<script>
import axios from 'axios';
export default {
  metaInfo(){
    return{
      title: 'S light production - foto galerija, vjenčanja, koncerti i događaji',
      meta:[
        {
          name: 'description',
          content: 'S light production - foto galerija - koncerti, svečanosti, modne revije, plesna događanja, promocije, televizijska snimanja, sajmovi, izložbe, vjenčanja, privatne zabave'
        }
      ]
    }
  },  
   data(){
      return{
        componentLoaded: false,
        currentID: 0,        
        images:'',
        originalImagesList:'',
        modalIsActive: false,
        categories: [
          {
            id: 0,
            name: 'Sve',
            isActive: false
          },           
          {
            id: 1,
            name: 'Vjenčanja',
            isActive: true
          },
          {
            id: 2,
            name: 'Koncerti',
            isActive: false
          }                           
        ]

      }  
   },
  methods:{
    fetchData(){
        axios({
          method: 'get',
          url: this.apiPath + 'gallery/readGalleryImages.php'
        })
        .then(function(response) {
          this.images = response.data;
          this.originalImagesList = this.images;

          this.componentLoaded = true;
          this.filterByCategory(0);
          this.checkCategoryMenuVisibility();                
        }.bind(this))
        .catch((error) => {
          console.log(error);
         });             
    },
    showModalWindow(id){
      this.modalIsActive = true;
      this.currentID = id;
    },
    closeModalWindow(){
      this.modalIsActive = false;
      this.currentID = 0;
    },
    sliderNext(){
      this.currentID = this.currentID >= this.images.length-1 ? 0 : this.currentID + 1;
    },
    sliderPrev(){
      this.currentID = this.currentID <= 0 ? this.images.length-1 : this.currentID - 1;
    },
    filterByCategory(categoryId){
      if(categoryId == 0){
        this.images = this.originalImagesList;
      }else{
        this.images = this.originalImagesList.filter(c => c.CategoryId.indexOf(categoryId) > -1);
      } 
      //Remove active links
      this.categories.forEach((link) => {
        link.isActive = false;
      });
        
      //Set active category
      var categoryIndexPosition = this.categories.findIndex(x=> x.id === categoryId);    
      this.categories[categoryIndexPosition].isActive = true;   
    },  
    checkCategoryMenuVisibility(){
      this.categories.forEach((category) => {
        if(this.originalImagesList.filter(c => c.CategoryId.indexOf(category.id) > -1).length <= 0 && category.id != 0){
          var objIndex = this.categories.findIndex((obj => obj.id == category.id));
          this.categories[objIndex].isVisible = false;
        }
      });          
    },      
    swipeHandler (direction) {
      console.log(direction);

      if(direction == "left"){
        this.sliderNext();
      }
      if(direction == "right"){
        this.sliderPrev();
      }
    }                   
   },
   computed: {
      getSrcLink: function() {
        return function(id) {
          if(! this.componentLoaded)
            return null;
          return this.dataPath + 'photo_gallery/' + this.images[id].Image;
      }
    }
   },   
   created(){
    this.fetchData();
    window.addEventListener('keydown', function(e) {
      if(this.modalIsActive == true){
        if(e.code == "ArrowLeft")
          this.currentID = this.currentID <= 0 ? this.images.length-1 : this.currentID - 1;
        else if(e.code == "ArrowRight")
          this.currentID = this.currentID >= this.images.length-1 ? 0 : this.currentID + 1;
      }
    });  
    document.title = 'Galerija - S light production - foto, video, oprema, rasvjeta za vjenčanja'  
    document.head.querySelector('meta[name=description]').content = 'Galerija - S light production - foto, video, rasvjeta za vjenčanja, specijalni efekti za razne događaje, teški dim, hladne fontane, umjetni snijeg, balončići';          
   } 
}
</script>

<style lang="scss">
.shell-fluid .range .image-item {
  opacity: 1 !important;
}
.image-item{
  cursor:pointer;
}

.page{ 
  .categories{
    ul{
      li {
        display: inline-block;
        margin-right: 20px;
        cursor: pointer;
        margin-bottom: 1rem;
        a {
          min-width: 0px;

          &.active{
            color: #ffffff;
            background-color: #a7cf38;
            border-color: #a7cf38;
          }
        }
      }
    }
  }
}

.hidden{
  display:none;
}

/****MODAL WINDOW*****/
.modal-gallery-navigation{
    width: 100%;
    position: absolute;
    z-index: 1161;
    bottom: 0;
    top: 0;
    margin: auto;
    height: 40px;

    .modal-navigation-arrow{
      height:40px;
      padding: .5rem;
      cursor: pointer;
      transition: box-shadow .3s;

      &:hover{
        opacity: .6;
      }

      &.left{
        float: left;
        margin-left: 8%;
      }
      &.right{
        float: right;
        margin-right: 8%;
      }
    }
}
/********************/

@media only screen and (max-width: 768px) {
  .page{   
    //Kategorije
    .categories{
      ul{
        li {
          margin:0;
          width: 48%;
          margin-bottom:1rem;
          margin-right: 0;
          &:first-child{
            width:100%;
          }

          &:nth-child(2){
            margin-right: 4%;
          }
          // &:nth-child(2n+0){
          //   margin-left: 4%;
          // }
          a {
            width:100%;
            padding: 1rem 0;
            margin: 0;            
            &.active{
              color: #ffffff;
              background-color: #a7cf38;
            }
          }
        }
      }
    }
    //Galerija
    .shell-fluid-mobile{
      .range{
        padding: 0 1rem;
        .image-item{
          width: 47.5%;
          max-width: 47.5%;
          margin-bottom: 1rem;

          &:nth-child(odd){
            margin-right: 5%;    
          }

          a{
            .thumb-ruby__caption{
              min-height: 100px !important;
              width: 100px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Galerija.vue